import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL;

export const fetchCurrentAffairById = async (id) => {
  const accessToken = localStorage.getItem('access_token');
  if (!accessToken) {
    return Promise.reject("Unauthorized");
  }

  try {
    const response = await axios.get(`${BASE_URL}current-affairs/${id}`, {
      headers: {
        'accept': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};




export const fetchPrevNextCurrentAffair = async ({
  current_affair_id,
  keywords,
  years ,
  months,
}) => {

  const accessToken = localStorage.getItem('access_token');
  if (!accessToken) {
    return Promise.reject("Unauthorized");
  }

  try {
    const response = await axios.post(
      `${BASE_URL}current-affairs/prev-next`,
      {
        current_affair_id,
        keywords,
        years,
        months,
      },
      {
        headers: {
          'accept': 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};



export const processCurrentAffairArticle = async (payload) => {
  const accessToken = localStorage.getItem("access_token");
  if (!accessToken) {
    return Promise.reject("Unauthorized");
  }

  try {
    const response = await axios.post(
      `${BASE_URL}current-affairs/adhoc`,
      payload,
      {
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};